async function refreshCartAndHeader() {
  const [cartRes, headerRes] = await Promise.all([
    fetch('/cart.js'),
    fetch('/?sections=header'),
  ]);

  const cartData = await cartRes.json();
  const headerHTML = await headerRes.json();

  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'custom',
    cartData,
  });

  const header = document.getElementById('shopify-section-header');
  if (header && headerHTML.header) {
    header.innerHTML = headerHTML.header;
  }
}

async function adHocSubmitATCFormAndRefreshCart(form_selector, fn=null) {
  const form = document.querySelector(form_selector);
  const formData = new FormData(form);
  await fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
  refreshCartAndHeader();
  if(fn) {
    fn();
  }
}

document.addEventListener('refresh:cart', () => {
  refreshCartAndHeader();
});